import React, { Component } from 'react';
import ControlledTabs from './components/ControlledTabs';
import { library } from '@fortawesome/fontawesome-svg-core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';

import { faStroopwafel } from '@fortawesome/free-solid-svg-icons';

library.add(faStroopwafel);

class App extends Component {
  render() {
    return (
      <MuiPickersUtilsProvider utils={MomentUtils}>
        <ControlledTabs {...this.props} />
      </MuiPickersUtilsProvider>
    );
  }
}

export default App;
